<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Combined Planograms PDF</h4>
  <button type="button" class="btn btn-link p-0 border-0" aria-label="Close" (click)="cancel()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body p-3">
  <p class="text-muted">
    Stitch several planograms of one store into a single PDF (overview and drop analysis only). Where one
    planogram ends in a half drop and the next begins with a half drop, the two are merged into one full drop.
  </p>

  <div class="mb-3">
    <label class="form-label">Store</label>
    <input type="text" class="form-control" placeholder="Search stores..."
           [(ngModel)]="storeModel"
           [ngbTypeahead]="searchStores"
           [resultFormatter]="storeFormatter"
           [inputFormatter]="storeFormatter"
           (selectItem)="onStoreSelect($event)" />
    <small class="text-muted" *ngIf="selectedStore">Store: <strong>{{ selectedStore.name }}</strong></small>
  </div>

  <div class="mb-3" *ngIf="selectedStore">
    <label class="form-label">Planograms in this store</label>
    <div *ngIf="isLoadingPlanograms" class="text-muted small">Loading…</div>
    <div *ngIf="!isLoadingPlanograms && availablePlanograms.length === 0" class="text-muted small">
      No planograms with a saved state were found for this store.
    </div>
    <div class="border rounded" style="max-height: 30vh; overflow-y: auto;" *ngIf="availablePlanograms.length > 0">
      <div class="form-check px-3 py-1 border-bottom" *ngFor="let p of availablePlanograms">
        <input class="form-check-input" type="checkbox" [id]="'combined-pg-' + p.guid"
               [checked]="isSelected(p)" (change)="togglePlanogram(p)" />
        <label class="form-check-label d-flex justify-content-between w-100" [for]="'combined-pg-' + p.guid">
          <span>{{ p.merchName }}</span>
          <span class="text-muted small">{{ p.drops }} drop{{ p.drops === 1 ? '' : 's' }} · {{ latestStateName(p) }}</span>
        </label>
      </div>
    </div>
  </div>

  <div class="mb-2" *ngIf="selected.length > 0">
    <label class="form-label">Selected — drag to set stitch order ({{ selected.length }})</label>
    <div cdkDropList (cdkDropListDropped)="drop($event)" class="d-flex flex-column gap-2">
      <div class="d-flex align-items-center gap-2 border rounded p-2" *ngFor="let item of selected" cdkDrag>
        <i class="bi bi-grip-vertical text-muted" cdkDragHandle style="cursor: grab;"></i>
        <span class="flex-grow-1 text-truncate">{{ item.planogram.merchName }}</span>
        <select class="form-select form-select-sm w-auto" [(ngModel)]="item.stateId">
          <option *ngFor="let st of item.planogram.states" [value]="st.guid">{{ st.name }}</option>
        </select>
        <button type="button" class="btn-close" aria-label="Remove" (click)="removeSelected(item)"></button>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-primary"
          [disabled]="selected.length === 0 || isExporting"
          (click)="export()">
    <span *ngIf="isExporting" class="spinner-border spinner-border-sm me-1" role="status"></span>
    Export{{ selected.length ? ' ' + selected.length : '' }} Planogram{{ selected.length === 1 ? '' : 's' }}
  </button>
</div>
